module.exports = __webpack_public_path__ + "static/media/Artboard.7242e12a.png";